<div class="page-head">

  <div class="row " style="padding-bottom: 2%;">
    <div class="col-md-5">
      <span>{{'ChooseClient' | translateOrgSpecific}}</span>
    </div>

  </div>

  <div class="row">
    <div class="col-md-12">
      <div class=" search-box-align">
        <div class="input-icons">
          <i class="fas fa-search" style="padding:7px;"></i>
          <input class="search-txt-box form-control  " type="text" [(ngModel)]="searchText" autocomplete="true">
        </div>


      </div>
    </div>

  </div>

</div>


<hr>
<div class="modal-body">



  <div class="card-data d-flex" style="height: 200px;overflow: auto;">
    <div *ngFor="let ele of patients | filter:searchText" class="case-list">
      <div>

        <div class="card" style=" cursor: pointer;"
          [ngClass]="{'highlight':!ele.isHighlight,'noHighlight':ele.isHighlight}" (click)="CardClick(ele)"
          name="ele.case_id">
          <div class="row" style=" cursor: pointer;">
            <div class="col-md-3">
              <img *ngIf="ele.profileImage"
                style="height:35px;margin-top: 20px;margin-left: 10px;border-radius: 16px;width: 35px;vertical-align: top;"
                class="img-circle" [src]="ele.profileImage">
              <i *ngIf="!ele.profileImage" class="fas fa-user-circle img-circle "
                style="font-size:25px;vertical-align: super; padding: 27px 5px 25px 7px;"></i>
            </div>
            <div class="col-md-9" style="padding-top:5px">
              <label style="font-size: 16px;">{{ele.displayName}}</label> <br>
              <div *ngIf="ele.age">Age: <label style="font-size: 16px;">{{ele.age}}</label> </div>


            </div>

          </div>
        </div>

      </div>

      <div *ngIf=" patients.length == 0" class="case-list">
        {{'Noclient' | translateOrgSpecific}}

      </div>
    </div>


  </div>



</div>

<div class="modal-footer">
  <div>
    <button (click)="closeModal()" class="btn btn-sm btn-apportis-tertiary btn-cancel"
      type="submit">{{'Cancel' | translateOrgSpecific}}</button>

    <button class="btn btn-sm btn-apportis-tertiary" (click)="clientSelect()" type="submit" style="width: 6.5rem;">
      {{'Next' | translateOrgSpecific}} </button>
  </div>
</div>